import { Decoder, field, string, succeed } from 'jsonous';
import { EventPoll } from './Types';

export const eventPollDecoder: Decoder<EventPoll> = succeed({}).assign(
  'pollUrl',
  field('poll_url', string),
);
